<template>
  <Transition
    enter-active-class="transition-opacity duration-150 ease-out"
    leave-active-class="transition-opacity duration-200 ease-in"
    enter-from-class="opacity-0"
    leave-to-class="opacity-0"
  >
    <div
      v-if="visible"
      class="pointer-events-none fixed inset-x-0 top-0 z-[9999] h-[2px] opacity-80"
      role="progressbar"
      :aria-valuenow="Math.round(progress)"
      aria-valuemin="0"
      aria-valuemax="100"
      aria-label="Loading"
    >
      <div class="relative h-full overflow-hidden bg-muted/30">
        <div
          class="h-full bg-primary/55 transition-[width] duration-200 ease-out"
          :style="{ width: `${progress}%` }"
        />
        <div
          class="absolute top-0 h-full w-16 -translate-x-1/2 bg-gradient-to-r from-transparent via-primary/35 to-transparent"
          :style="{ left: `${progress}%` }"
        />
      </div>
    </div>
  </Transition>
</template>

<script setup lang="ts">
import { useRequestProgress } from '@/shared/api/request-progress';

const { progress, visible } = useRequestProgress();
</script>
